export default "__VITE_ASSET__BBm_fgqn__"